document.addEventListener("DOMContentLoaded", function () {
  let productObserver = new MutationObserver((mutations, productObs) => {
    let productMeta = document.querySelector(".product-single__meta");

    if (productMeta) {
      productObs.disconnect(); // Stop observing once .product-single__meta is found

      let optionsObserver = new MutationObserver((mutations, optionsObs) => {
        let optionsContainer = document.querySelector(
          "#infiniteoptions-container"
        );

        if (optionsContainer && optionsContainer.children.length > 0) {
          // Check if it's not empty
          let existingHeading =
            optionsContainer.parentNode.querySelector(".custom-heading");
          if (!existingHeading) {
            let heading = document.createElement("h3");
            heading.textContent = "Customize your product";
            heading.classList.add("custom-heading");

            optionsContainer.parentNode.prepend(heading);
          }
          optionsObs.disconnect(); // Stop observing once heading is added
        }
      });

      // Observe changes within .product-single__meta
      optionsObserver.observe(productMeta, {
        childList: true,
        subtree: true,
      });
    }
  });

  // Observe the document body to detect when .product-single__meta appears
  productObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
